<template>
   <div class="content">
       <div class="left-box">
        <el-tooltip class="item" effect="dark" :content="title+'实训记录'" placement="top-start">
            <p class="title overflow">{{title}}实训记录</p>
        </el-tooltip>
           <div class="record-box" v-infinite-scroll="loadTrain">
               <no-data v-if="softwareList.length==0"></no-data>
               <div v-for="(item,index) in softwareList" class="train-item" @click="changeTrain(item)" :class="[{'line-active':optFlag==item.optFlag}]" :key="index">
                   <p class="software-name" :class="{'active-blue':optFlag==item.optFlag}">{{ item.softwareName }}</p>
                   <p class="start-time">开始时间:{{ item.startTime }}</p>
                   <div class="bottom">
                       <div style="width: 55%;">
                           <p>在线时长:</p>
                           <el-tooltip effect="dark" :content="item.onlineTime?item.onlineTime.toString():''" placement="top-start">
                                <p class="overflow" style="flex: 1;">{{ item.onlineTime }}</p>
                           </el-tooltip>
                       </div>
                       <div style="padding-left: 1rem;width: 45%;">
                           <p>实训总分:</p>
                           <el-tooltip effect="dark" :content="item.drillGrossScore?item.drillGrossScore.toString():''" placement="top-start">
                            <p class="overflow" style="flex: 1;">{{ item.drillGrossScore }}</p>
                           </el-tooltip>
                       </div>
                   </div>
               </div>
           </div>
       </div>
       <div class="right-box">
            <div class="top-box">
                <p class="title" style="margin-left: 2rem;">操作记录</p>
                <div class="input-box">
                    <div @click="search">搜索</div>
                    <el-input v-model="dPages.keywords" @keydown.enter.native="search" clearable @clear="search" style="width: 20rem;" placeholder="请输入名称">
                        <template slot="prefix">
                            <div class="search-ipt-box">
                                <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
           <div class="table-box">
               <Table
                   :totalSize="dPages.total"
                   :pagination="true"
                   :operationWidth="350"
                   :currentPage="dPages.current"
                   @changeCurrentPage="changeCurrentPage"
                   @changePageSize="changePageSize"
                   :pageSize="dPages.size"
                   navHeight=40
                   ref="table"
                   :tableData="detailList"
                   :tableKey="tableKey"
               >
               <template slot="courseCount" slot-scope="data">
                   <p style="color: #387DFF;cursor: pointer;">{{ data.data.row.courseCount }}</p>
               </template>
           </Table>
           </div>
       </div>
   </div>
</template>

<script>
import { PageQuerySoftwareDrillDetail,PageQuerySoftwareModulesDrillDetailList } from '@/api/virtualSoftware';
import NoData from '../../common/NoData.vue';
export default {
 components: { NoData },
        props:['userId'],
       data(){
           return {
                dialogVisible:false,
                softwareCode:'',
                title:'',
                optFlag:'',
                /**仿真软件列表 */
                softwareList:[],
                /**实训详情列表 */
                detailList:[],
                /**软件分页 */
               pages:{
                   current:1,
                   size:10,
                   total:0
               },
               /**详情分页 */
               dPages:{
                   current:1,
                   size:10,
                   total:0
               },
               currentSoftware:{},
               tableKey:[
                   {name: '操作名称', value: 'optDescribe',width:'180px'},
                   {name: '操作时长', value: 'optTime'},
                   {name: '开始时间', value: 'startTime',width:'150px'},
                   {name: '结束时间', value: 'endTime',width:'150px'},
                   {name: '满分', value: 'fullScore'},
                   {name: '得分', value: 'score'},
               ]
           }
       },
       methods:{
            search(){
                this.dPages.current=1;
                this.pageQuerySoftwareDrillDetailList();
            },
             /**获取仿真软件记录 */
             pageQuerySoftwareDrillList(){
                var params={
                    "softwareCode": this.softwareCode,
                    "current":this.pages.current,
                    "size":this.pages.size,
                }
                if(this.userId){
                    params.userId=this.userId;
                }
                PageQuerySoftwareDrillDetail(params).then(res=>{
                    if(res.code==200){
                        if(this.pages.current==1){
                            this.softwareList=res.data.records;
                            this.pages.total=res.data.total;
                            if(this.softwareList.length>0){
                                this.optFlag=this.softwareList[0].optFlag;
                                this.pageQuerySoftwareDrillDetailList();
                            }else{
                                this.optFlag='';
                                this.detailList=[];
                            }
                        }else{
                            this.softwareList=[...this.softwareList,...res.data.records];
                            this.pages.total=res.data.total;
                        }
                    }
                })
            },
            /**分页查询虚仿实训详情记录 */
            pageQuerySoftwareDrillDetailList(){
                var params={
                "moduleName":this.dPages.keywords,
                "current": this.dPages.current,
                "optFlag": this.optFlag,
                "size": this.dPages.size,
                };
                if(this.userId){
                    params.createId=this.userId;
                }
                PageQuerySoftwareModulesDrillDetailList(params).then(res=>{
                    if(res.code==200){
                        res.data.records.forEach(item=>{
                            item.name=item.optDescribe.split('完成')[1];
                        })
                        this.detailList=res.data.records;
                        this.dPages.total=res.data.total;
                    }
                })
            },
           /**切换实训 */
           changeTrain(item){
               this.dPages.current=1;
               this.optFlag=item.optFlag;
               this.search();
           },
           /**下拉加载实训详情 */
           loadTrain(){
               let total=this.pages.current*this.pages.size;
               if(total>=this.pages.total)return;
               this.pages.current++;
               this.pageQuerySoftwareDrillList();
               console.log('loading........')
           },
           changeCurrentPage(e){
               this.dPages.current=e;
               this.pageQuerySoftwareDrillDetailList();
           },
           changePageSize(e){
               this.dPages.current=1;
               this.dPages.size=e;
               this.pageQuerySoftwareDrillDetailList();
           }
       },
       mounted(){
        var html= document.getElementsByTagName('html')[0];
        window.addEventListener('resize',()=>{
            let width=html.style.fontSize;
            let arr=width.split('px');
            this.$set(this.tableKey[2],'width',(parseInt(arr[0]*15))+'px')
            this.$set(this.tableKey[3],'width',parseInt(arr[0]*15)+'px')
        })
       }
   }
</script>

<style lang="less" scoped>
.content{
   height: 53rem;
   display: flex;
   color: #334681;
   .left-box{
       background-color: #ffffff;
       border: 1px solid #e5edf7;
        border-radius: 1.5rem;
        box-shadow: 0px 0px 1.5rem 0px rgba(231,236,239,0.10); 
        width: 25.5rem;
   }
   .right-box{
       padding: 2rem 0;
       border: 1px solid #e0e8f2;
    //    border-top: 1px solid #e0e8f2;
    //    border-bottom: 1px solid #e0e8f2;
       border-radius: 1.5rem;
       box-shadow: 0px 0px 1.5rem 0px rgba(231,236,239,0.10); 
       width: calc(100% - 27rem);
       background-color: #ffffff;
       margin-left: 1.7rem;
   }
}
.title{
           font-weight: 700;
           font-size: 16px;
           padding: 2rem 1.5rem;
   }
.table-box{
   height: calc(100% - 8rem);
   width: 100%;
   margin-top: 2.5rem;
   padding: 0 2.2rem;
}
.record-box{
   height: calc(100% - 8rem);
   overflow:auto;
   overflow-x: hidden ;
   .train-item{
       width: 100%;
       padding: 2rem 2.1rem;
       position: relative;
       cursor: pointer;
       border-left: 3px solid transparent;
   }
}
.software-name{
   font-weight: 700;
}
.start-time{
   color: #8590B3;
   font-size: 12px;
   margin-top: 1rem;
}
.bottom{
   font-size: 14px;
   margin-top: 1.3rem;
   display: flex;
   justify-content: space-between;
   &> :nth-child(n){
       display: flex;
       &> :nth-child(1){
           color: #8590B3;
       }
       &> :nth-child(2){
           font-weight: 700;
       }
   }
}
.line-active{
    border-left: 3px solid var(--blue) !important;
    background: #f4f7fb;
}
/deep/.nodata-img{
   width: 12rem !important;
}
.input-box{
    display: flex;
    align-items: center;
    &> :nth-child(1){
    color: #8590B3;
    margin-right: 1rem;
   }
}
.input-box{
    margin-right: 2.2rem;
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.top-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.active-blue{
    color: var(--blue) !important;
}
@media screen and (max-width:750px){
    .content{
        display: block;
        &> :nth-child(n){
            width: 100%;
        }
    }
    .right-box{
        margin-left: 0 !important;
        margin-top: 2rem;
    }
}
</style>